import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, SxProps, Theme } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ConfirmationDialog } from "../../ConfirmationDialog";
import { DeleteButton } from "../IconButtons/DeleteButton";

interface Props {
  confirmationDialogMessage: string;
  confirmationDialogHeader: string;
  onConfirmDeleteButtonClick: () => void;
  variant?: "default" | "icon";
  disabled?: boolean;
  sx?: SxProps<Theme>;
  toolTipText?: string;
}

export default function DeleteConfirmationButton(props: React.PropsWithChildren<Props>) {
  const { t } = useTranslation();

  const { confirmationDialogHeader, confirmationDialogMessage, onConfirmDeleteButtonClick, variant, disabled, sx } =
    props;

  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  function handleDeleteButtonClick() {
    setShowConfirmationDialog(true);
  }

  function closeConfirmationDialog() {
    setShowConfirmationDialog(false);
  }

  return (
    <>
      {variant === "icon" ? (
        <DeleteButton onClick={handleDeleteButtonClick} disabled={disabled} />
      ) : (
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteForeverIcon />}
          onClick={handleDeleteButtonClick}
          disabled={disabled}
          sx={sx}
        >
          {props.children || t("common.delete")}
        </Button>
      )}
      {showConfirmationDialog && (
        <ConfirmationDialog
          header={confirmationDialogHeader}
          message={confirmationDialogMessage}
          onAccept={onConfirmDeleteButtonClick}
          onClose={closeConfirmationDialog}
          visible={showConfirmationDialog}
          closeMessage={t("common.cancel")}
          icon="warning"
          confirmButtonColor="error"
        />
      )}
    </>
  );
}
